<template>
    <div class="download">
        <van-nav-bar
            title="酒店信息"
            left-arrow
            @click-left="onClickLeft"
        />
        <div class="buttons">
            <img style="width: 32%;" src="./images/16.png"  @click="skip()"/>
            <img style="width: 65%;" src="./images/17.png"  @click="goImage"/>
        </div>
        <img src="@/assets/images/cvscf2023/bottom.png" class="bottom"/>
    </div>
</template>

<script>
import Top from '../VascularSystem/components/Top.vue'
import { ButtonDetail } from '../../config/interface.js'
export default {
    components:{
        Top
    },
    data(){
        return{
             address_url:''
        }
    },
    created(){
        this.button_id=this.$route.query.button_id?this.$route.query.button_id:this.$route.query.b_id;
        this.getButtonData();
    },
    methods:{
        goDetail(type){

        },
        //获取按钮信息
        getButtonData(){
            if(this.button_id){
                const url=ButtonDetail;
                let params={
                    button_id:this.button_id
                }
                const method="POST";
                fetch(url,params,method)
                .then((res)=>{
                    if(res.code==0){
                        this.address_url=res.data.url
                        document.title=res.data.share_title;
                        if(common.is_weixin()){
                            let data=res.data;
                            common.wxShare(data.share_title,data.share_sub_title,data.share_img);
                        }
                    }
                })

            }
        },
        onClickLeft(){
            this.$router.push('/XVC/index')
        },
        skip(){
            window.location.href=this.address_url
        },
        goImage(){
            window.location.href="http://cdn.edstatic.com/203012120000/f9b1a5b17af5ec57af121309115b4ebc/2024/07/d8b49aaf-eff9-4e4c-b70a-b089d514665f.png"
        }
    }
}
</script>

<style lang="scss" scoped>
.van-nav-bar{
    background: #d8261d;
    .van-icon{
        color: white;
    }
}
.van-nav-bar /deep/.van-icon {
    color: white;
}
 .van-nav-bar /deep/.van-nav-bar__title{
    color: white;
    font-size: 16px;
    letter-spacing: 0.5px;
}
.download{
    .buttons{
        padding:15% 5%;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        img{
            width: 48%;
            margin-bottom: 4%;
            border-radius:10px;
        }
    }
    .bottom{
        position: absolute;
        width: 100%;
        bottom: 0;

    }
}
</style>


// WEBPACK FOOTER //
// src/pages/XVC/hotel.vue